/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemovePlayerFromTeamRequest
 */
export interface RemovePlayerFromTeamRequest {
    /**
     * ID of the team to remove player from
     * @type {string}
     * @memberof RemovePlayerFromTeamRequest
     */
    teamId: string;
}

/**
 * Check if a given object implements the RemovePlayerFromTeamRequest interface.
 */
export function instanceOfRemovePlayerFromTeamRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function RemovePlayerFromTeamRequestFromJSON(json: any): RemovePlayerFromTeamRequest {
    return RemovePlayerFromTeamRequestFromJSONTyped(json, false);
}

export function RemovePlayerFromTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemovePlayerFromTeamRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
    };
}

export function RemovePlayerFromTeamRequestToJSON(value?: RemovePlayerFromTeamRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamId': value.teamId,
    };
}

